import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { UserSize } from "@/app/graphql/codegen";

interface SeatCountDisplayProps {
  count: number;
  total?: number;
  size?: UserSize | "TOTAL";
  label?: string;
  showBadge?: boolean;
}

const SeatCountDisplay: React.FC<SeatCountDisplayProps> = ({
  count,
  total,
  size = "TOTAL",
  label,
  showBadge = true,
}) => {
  const theme = useTheme();

  // Bestimme die Farbe basierend auf der Größe
  const getBadgeColor = () => {
    return theme.palette.semantic.planSize[size as keyof typeof theme.palette.semantic.planSize];
  };
  
  // Zeige Badge nur für S/M/L, nicht für TOTAL
  const shouldShowBadge = showBadge && size !== "TOTAL";
  // Zeige Label nur für TOTAL
  const shouldShowLabel = size === "TOTAL" && label;

  return (
    <Box
      sx={{
        position: "relative",
        border: 1,
        borderColor: getBadgeColor(),
        borderRadius: 1,
        p: 0.7,
        pr: "1.8rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255,255,255,0.8)",
        width: "auto",
        minWidth: "100px",
        maxWidth: "100%",
      }}
    >
      {shouldShowBadge && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            bgcolor: getBadgeColor(),
            color: "white",
            px: 1,
            py: 0.05,
            borderBottomLeftRadius: 8,
            borderTopRightRadius: 8,
            fontWeight: "bold",
            zIndex: 1,
            fontSize: "0.95rem",
          }}
        >
          {size}
        </Box>
      )}
      <Box sx={{ textAlign: "center" }}>
        {shouldShowLabel && (
          <Typography 
            variant="body1" 
            color="text.primary" 
            gutterBottom 
            sx={{ 
              fontWeight: "bold", 
              fontSize: "0.95rem",
              mb: 0.2
            }}
          >
            {label}
          </Typography>
        )}
        <Typography variant="h6" sx={{ fontWeight: "medium", fontSize: "1.1rem" }}>
          <Box component="span" sx={{ color: getBadgeColor(), fontWeight: "bold", mr: 0.3 }}>
            {count}
          </Box>
          {total !== undefined && (
            <>
              / {total}
            </>
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default SeatCountDisplay; 